
<template>
  <sAlert
    class="bidding-type-info">
    {{ title }}
    <template slot="desc">
      <div
        v-dompurify-html="description"
        class="bidding-type-info__description"/>
    </template>
  </sAlert>
</template>

<script>
/**
 * Информация по типу торгов
 */
export default {
  name: 'biddingTypeInfo',
  props: {
    type: Object,
  },
  computed: {
    description() {
      return this.$t('Tenders.BidType.Description')[this.type?.oldCode] || ''
    },
    title() {
      return this.type.titleRu
    }
  }
}
</script>

<style lang="scss" scoped>
.bidding-type-info {
  max-width: 400px ;
  &__opportunities {
    white-space: normal;
  }
}
.bidding-type-info__description {
  font-size: 12px!important;
  line-height: 16px!important;
  font-weight: 400!important;
  letter-spacing: normal;
}

</style>
